export default "__VITE_ASSET__22361177__"